export function stripIbgeMunicipalityDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 7);
}
